import classnames from 'classnames';
import { useSyncedRef } from '../../hooks/use-synced-ref';
import { useTabKeyNavigation } from '../../hooks/use-tab-key-navigation';
import { downcastRef } from '../../util/typing';
import Overlay from '../layout/Overlay';
import Dialog from './Dialog';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * Show a modal dialog
 */
export default function ModalDialog({
  children,
  disableCloseOnEscape = false,
  disableFocusTrap = false,
  disableRestoreFocus = false,
  size = 'md',
  classes,
  elementRef,
  // Forwarded to Dialog
  closeOnClickAway = false,
  closeOnFocusAway = false,
  initialFocus = 'auto',
  ...htmlAndPanelAttributes
}) {
  const modalRef = useSyncedRef(elementRef);
  useTabKeyNavigation(modalRef, {
    enabled: !disableFocusTrap
  });
  return _jsx(Overlay, {
    "data-composite-component": "ModalDialog",
    children: _jsx(Dialog
    // Attribute defaults; can be overridden
    , {
      "aria-modal": true,
      ...htmlAndPanelAttributes,
      // Dialog props
      closeOnClickAway: closeOnClickAway,
      closeOnFocusAway: closeOnFocusAway,
      closeOnEscape: !disableCloseOnEscape,
      initialFocus: initialFocus,
      restoreFocus: !disableRestoreFocus,
      classes: classnames(
      // Column-flex layout to constrain content to max-height
      'flex flex-col', size !== 'custom' && 'max-w-[90vw] max-h-[90vh]',
      // Overlay sets up a flex layout centered on both axes. For taller
      // viewports, remove this modal container from the flex flow with
      // fixed positioning and position it 10vh from the top of the
      // viewport. This feels more balanced on taller screens. Ensure an
      // equal 10vh gap at the bottom of the screen by adjusting max-height
      // to `80vh`.
      size !== 'custom' && 'tall:fixed tall:max-h-[80vh] tall:top-[10vh]', {
        // Max-width rules will ensure actual width never exceeds 90vw
        'w-[30rem]': size === 'sm',
        'w-[36rem]': size === 'md',
        // default
        'w-[42rem]': size === 'lg'
        // No width classes are added if `size` is 'custom'
      }, classes),
      elementRef: downcastRef(modalRef),
      "data-modal-size": size,
      children: children
    })
  });
}
//# sourceMappingURL=ModalDialog.js.map